import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { speedingsQueryKeys } from "./queryKeys"
import { useSpeedingsQuery } from "./useSpeedingsQueries"

export function useSpeedingsProject() {
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork.slug}/`

    const queryKey = speedingsQueryKeys.project()

    return useSpeedingsQuery(
        url,
        queryKey,
    )
}